
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"16","viewBox":"0 0 17 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9 2c3.844 0 7 2.469 7 5.5S12.844 13 9 13a9.191 9.191 0 01-2.625-.375l-.469-.156-.406.281c-.719.5-1.813 1.094-3.188 1.25a8.61 8.61 0 001.25-2.188l.22-.593-.407-.438C2.469 9.812 2 8.687 2 7.5 2 4.469 5.125 2 9 2zm0-1C4.562 1 1 3.938 1 7.5c0 1.5.594 2.875 1.625 3.969-.438 1.219-1.406 2.281-1.438 2.281-.218.219-.25.531-.156.813A.75.75 0 001.72 15c1.937 0 3.437-.781 4.375-1.438A9.753 9.753 0 009 14c4.406 0 8-2.906 8-6.5C17 3.937 13.406 1 9 1z","fill":"#4461D7"}})])
          )
        }
      }
    